import {
  FETCH_CANCELLATIONS_REQUEST,
  FETCH_CANCELLATIONS_SUCCESS,
  FETCH_CANCELLATIONS_FAILURE,
  CREATE_CANCELLATION_INVOICE_REQUEST,
  CREATE_CANCELLATION_INVOICE_SUCCESS,
  CREATE_CANCELLATION_INVOICE_FAILURE,
  UPDATE_CANCELLATION_STATUS_REQUEST,
  UPDATE_CANCELLATION_STATUS_SUCCESS,
  UPDATE_CANCELLATION_STATUS_FAILURE,
  FETCH_CANCELLATION_STATISTICS_REQUEST,
  FETCH_CANCELLATION_STATISTICS_SUCCESS,
  FETCH_CANCELLATION_STATISTICS_FAILURE,
} from "./actionTypes";

const initialState = {
  cancellations: [],
  statistics: {
    total_cancellations: 0,
    early_cancellations: 0,
    late_cancellations: 0,
    total_fines: 0,
    pending_invoices: 0,
  },
  loading: false,
  error: null,
  creatingInvoice: false,
  updatingStatus: false,
};

export default function cancellationsReducer(state = initialState, action) {
  switch (action.type) {
    // Fetch Cancellations
    case FETCH_CANCELLATIONS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_CANCELLATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        cancellations: action.payload || [],
        error: null,
      };
    case FETCH_CANCELLATIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload || "Failed to fetch cancellations",
      };

    // Create Cancellation Invoice
    case CREATE_CANCELLATION_INVOICE_REQUEST:
      return {
        ...state,
        creatingInvoice: true,
        error: null,
      };
    case CREATE_CANCELLATION_INVOICE_SUCCESS:
      return {
        ...state,
        creatingInvoice: false,
        cancellations: [action.payload, ...state.cancellations],
        error: null,
      };
    case CREATE_CANCELLATION_INVOICE_FAILURE:
      return {
        ...state,
        creatingInvoice: false,
        error: action.payload || "Failed to create cancellation invoice",
      };

    // Update Cancellation Status
    case UPDATE_CANCELLATION_STATUS_REQUEST:
      return {
        ...state,
        updatingStatus: true,
        error: null,
      };
    case UPDATE_CANCELLATION_STATUS_SUCCESS:
      return {
        ...state,
        updatingStatus: false,
        cancellations: state.cancellations.map((c) =>
          c.id === action.payload.id ? action.payload : c
        ),
        error: null,
      };
    case UPDATE_CANCELLATION_STATUS_FAILURE:
      return {
        ...state,
        updatingStatus: false,
        error: action.payload || "Failed to update cancellation status",
      };

    // Fetch Cancellation Statistics
    case FETCH_CANCELLATION_STATISTICS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_CANCELLATION_STATISTICS_SUCCESS:
      return {
        ...state,
        loading: false,
        statistics: action.payload || initialState.statistics,
        error: null,
      };
    case FETCH_CANCELLATION_STATISTICS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload || "Failed to fetch statistics",
      };

    default:
      return state;
  }
}
